// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-code-editor {
  display: grid;
  min-height: 240px;
  border: 1px solid #dbe7ff;
  border-radius: 12px;
  background: #ffffff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.custom-code-editor:focus-within {
  border-color: #93b5ff;
  box-shadow: 0 0 0 1px #93b5ff;
}

.custom-code-editor--disabled {
  background: #f6f8ff;
}

.custom-code-editor__highlight,
.custom-code-editor__input {
  grid-area: 1 / 1;
  margin: 0;
  padding: 12px;
  font-family: Menlo, Monaco, Consolas, 'Liberation Mono', monospace;
  font-size: 12px;
  line-height: 20px;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  -moz-tab-size: 2;
    -o-tab-size: 2;
       tab-size: 2;
}

.custom-code-editor__highlight {
  pointer-events: none;
  color: #27344a;
  overflow: hidden;
}

.custom-code-editor__highlight code {
  display: block;
  min-height: 100%;
}

.custom-code-editor__input {
  min-height: 240px;
  width: 100%;
  resize: vertical;
  border: 0;
  background: transparent;
  color: transparent;
  caret-color: #27344a;
  outline: none;
  overflow: auto;
}

.custom-code-editor__input::-moz-placeholder {
  color: #9ca3af;
}

.custom-code-editor__input::placeholder {
  color: #9ca3af;
}

.custom-code-editor--disabled .custom-code-editor__input {
  cursor: not-allowed;
}

.custom-code-preview {
  border: 1px solid #dbe7ff;
  border-radius: 12px;
  background: #ffffff;
  max-height: 280px;
  overflow: auto;
}

.custom-code-preview__highlight {
  margin: 0;
  padding: 12px;
  font-family: Menlo, Monaco, Consolas, 'Liberation Mono', monospace;
  font-size: 12px;
  line-height: 20px;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  -moz-tab-size: 2;
    -o-tab-size: 2;
       tab-size: 2;
  color: #27344a;
}

.custom-code-preview__highlight code {
  display: block;
  min-height: 100%;
}

.custom-code-editor__token--comment {
  color: #6b7280;
  font-style: italic;
}

.custom-code-editor__token--string {
  color: #b45309;
}

.custom-code-editor__token--keyword {
  color: #1d4ed8;
}

.custom-code-editor__token--number {
  color: #c2410c;
}

.custom-code-editor__token--property,
.custom-code-editor__token--attr-name {
  color: #0f766e;
}

.custom-code-editor__token--tag-name {
  color: #1e40af;
}

.custom-code-editor__token--punctuation {
  color: #64748b;
}
`, "",{"version":3,"sources":["webpack://./src/styles/custom-code-editor.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,wDAAwD;AAC1D;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,kEAAkE;EAClE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;EACvB,gBAAW;IAAX,cAAW;OAAX,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAFA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,kEAAkE;EAClE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;EACvB,gBAAW;IAAX,cAAW;OAAX,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".custom-code-editor {\n  display: grid;\n  min-height: 240px;\n  border: 1px solid #dbe7ff;\n  border-radius: 12px;\n  background: #ffffff;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.custom-code-editor:focus-within {\n  border-color: #93b5ff;\n  box-shadow: 0 0 0 1px #93b5ff;\n}\n\n.custom-code-editor--disabled {\n  background: #f6f8ff;\n}\n\n.custom-code-editor__highlight,\n.custom-code-editor__input {\n  grid-area: 1 / 1;\n  margin: 0;\n  padding: 12px;\n  font-family: Menlo, Monaco, Consolas, 'Liberation Mono', monospace;\n  font-size: 12px;\n  line-height: 20px;\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n  tab-size: 2;\n}\n\n.custom-code-editor__highlight {\n  pointer-events: none;\n  color: #27344a;\n  overflow: hidden;\n}\n\n.custom-code-editor__highlight code {\n  display: block;\n  min-height: 100%;\n}\n\n.custom-code-editor__input {\n  min-height: 240px;\n  width: 100%;\n  resize: vertical;\n  border: 0;\n  background: transparent;\n  color: transparent;\n  caret-color: #27344a;\n  outline: none;\n  overflow: auto;\n}\n\n.custom-code-editor__input::placeholder {\n  color: #9ca3af;\n}\n\n.custom-code-editor--disabled .custom-code-editor__input {\n  cursor: not-allowed;\n}\n\n.custom-code-preview {\n  border: 1px solid #dbe7ff;\n  border-radius: 12px;\n  background: #ffffff;\n  max-height: 280px;\n  overflow: auto;\n}\n\n.custom-code-preview__highlight {\n  margin: 0;\n  padding: 12px;\n  font-family: Menlo, Monaco, Consolas, 'Liberation Mono', monospace;\n  font-size: 12px;\n  line-height: 20px;\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n  tab-size: 2;\n  color: #27344a;\n}\n\n.custom-code-preview__highlight code {\n  display: block;\n  min-height: 100%;\n}\n\n.custom-code-editor__token--comment {\n  color: #6b7280;\n  font-style: italic;\n}\n\n.custom-code-editor__token--string {\n  color: #b45309;\n}\n\n.custom-code-editor__token--keyword {\n  color: #1d4ed8;\n}\n\n.custom-code-editor__token--number {\n  color: #c2410c;\n}\n\n.custom-code-editor__token--property,\n.custom-code-editor__token--attr-name {\n  color: #0f766e;\n}\n\n.custom-code-editor__token--tag-name {\n  color: #1e40af;\n}\n\n.custom-code-editor__token--punctuation {\n  color: #64748b;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
